import * as React from 'react';
import styled from 'styled-components';

export const PropertyName = styled.div`
  color: #0C4D82;
  font-size: 1.2vw;
  font-weight: bold;
  cursor: pointer;
`;

export default class ExpandableProperty extends React.Component{
  
  constructor(props){
    super(props);
    this.state ={
      isOpen: !!props.expanded
    }
  }

  render() {

    const { title } =  this.props;
    const { isOpen } = this.state;
    const { children } = this.props;

    return (
      <>
        <PropertyName onClick={() => this.setState(prevState => ({ isOpen: !prevState.isOpen }))}>
          {title}
          {isOpen ? '-' : '+'}
        </PropertyName>
        
        {isOpen ? children: null}
        
        {React.Children.count(children) === 0 && isOpen ? 'The list is empty!' : null}
        
      </>
    );
  }
}